/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DateRangeModel } from '../../models/date-range-model';
import { HealthScoreModel } from '../../models/health-score-model';

export interface ConsumerConsumerHealthScoreHistoryPost$Params {
  
    /**
     * Date range model specifying the time period for health score history.
     */
    body?: DateRangeModel
}

export function consumerConsumerHealthScoreHistoryPost(http: HttpClient, rootUrl: string, params?: ConsumerConsumerHealthScoreHistoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HealthScoreModel>>> {
  const rb = new RequestBuilder(rootUrl, consumerConsumerHealthScoreHistoryPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HealthScoreModel>>;
    })
  );
}

consumerConsumerHealthScoreHistoryPost.PATH = '/Consumer/ConsumerHealthScoreHistory';
